var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWwStep10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 65,
    viewBox: "0 0 73 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8936 8.13625C39.6033 4.97686 44.2805 1.42395 51.3976 1.42395C63.8552 1.42395 72.2091 13.1171 72.2091 24.0007C72.2091 46.7573 43.8645 64.1958 36.8936 64.1958C29.9227 64.1958 1.57812 46.7685 1.57812 24.0119C1.57812 13.1171 9.93196 1.43519 22.3896 1.43519C29.5067 1.42395 34.1839 4.97686 36.8936 8.13625Z",
    fill: "#63C7C9",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9384 13.5893C39.2433 10.8909 43.2347 7.86641 49.2949 7.86641C59.9086 7.86641 67.0257 17.828 67.0257 27.1151C67.0257 46.5099 42.8749 61.3737 36.9271 61.3737C30.9794 61.3737 6.83984 46.5099 6.83984 27.1038C6.83984 17.828 13.9569 7.85516 24.5707 7.85516C30.6421 7.86641 34.6335 10.8909 36.9384 13.5893Z",
    fill: "white",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6172 28.3181C43.6172 27.0476 43.2799 25.7996 42.639 24.709C41.9982 23.6184 41.065 22.7189 39.9519 22.1005C38.8388 21.4934 37.5795 21.1898 36.309 21.2235C35.0385 21.2685 33.8017 21.6508 32.7336 22.3254C31.6655 23.0112 30.7998 23.9669 30.2263 25.1025C29.6529 26.2381 29.3943 27.5086 29.4843 28.7679C29.5742 30.0384 29.9902 31.2526 30.7211 32.2983C31.4406 33.3439 32.43 34.1759 33.5881 34.7156L30.6536 46.004H42.4479L39.5134 34.7156C40.7389 34.1534 41.7733 33.254 42.5041 32.1184C43.2237 30.994 43.6172 29.6673 43.6172 28.3181Z",
    fill: "#5458F7",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWwStep10);
export default __webpack_public_path__ + "static/media/ww-step10.240787a9.svg";
export { ForwardRef as ReactComponent };